import { ReviewReferenceLabel, ReviewReferenceNotice, isReviewReference } from "./DiscoveryReferenceLabels.jsx";
import { useState } from "react";
import { discoveryGroupsSpec, findingValueLabel, discoveryTopicLabel, organizationLabel, isOrganizationAxis } from "../lib/discoveryQueries.js";
import { useDiscoveryQuery } from "../lib/useDiscoveryQuery.js";
import { EndpointName } from "./EndpointName.jsx";
import Select from "./Select.jsx";
import { buttonClass } from "./ui/Button.jsx";
import { FIELD } from "./ui/styles.js";

export default function DiscoveryScopeValuePicker({ axes, filters, relationship, timeRange, contextKey, topicGeneration, onChange }) {
    const [axis, setAxis] = useState("");
    const [draft, setDraft] = useState("");
    const [search, setSearch] = useState("");
    let spec = null, error = null;
    try {
        if (axis) spec = discoveryGroupsSpec({ timeRange, filters: filters.filter((f) => f.axis !== axis), relationship, axis, unit: "sessions", search, topicGeneration });
    } catch (e) { error = e.message; }
    const result = useDiscoveryQuery(spec, contextKey);
    const selected = filters.find((f) => f.axis === axis);
    return <div className="discovery-value-picker">
        <label>Find an endpoint, organization or other value<Select ariaLabel="Filter attribute" value={axis} placeholder="Choose an attribute" onChange={(next) => { setAxis(next); setSearch(""); setDraft(""); }}
            options={axes.map((a) => ({ value: a.id, label: a.label }))} /></label>
        {axis && <>
            <ReviewReferenceNotice axis={axis} />
            <form onSubmit={(e) => { e.preventDefault(); setSearch(draft); }}>
                <label>{isReviewReference(axis) ? "Search reference ID" : `Search ${axes.find((a) => a.id === axis)?.label}`}<input aria-label="Search filter values" maxLength={160} value={draft} onChange={(e) => setDraft(e.target.value)} className={`${FIELD} w-full`} /></label>
                <button type="submit" className={buttonClass("secondary", "md")}>Search</button>
            </form>
            <div aria-busy={result.status === "loading"}>
                {error && <p role="alert">{error}</p>}
                {result.status === "loading" && <p role="status">Loading values...</p>}
                {result.status === "error" && <p role="alert">Could not load filter values. Use Refresh to try again.</p>}
                <button aria-pressed={!selected} onClick={() => onChange(axis, undefined)}>Any</button>
                {result.rows.map((row) => <button key={JSON.stringify(row.value)} aria-pressed={selected?.value === row.value} onClick={() => onChange(axis, row.value, axis === "topic" ? { generationId: topicGeneration, label: discoveryTopicLabel(row.value, row.topic_name) } : null)}>
                    <span>{isReviewReference(axis) ? <ReviewReferenceLabel axis={axis} value={row.value} /> : axis === "endpoint" ? <EndpointName id={row.value} fallback={row.value ? "Unnamed endpoint" : "Unattributed"} /> : axis === "topic" ? discoveryTopicLabel(row.value, row.topic_name) : isOrganizationAxis(axis) ? organizationLabel(row.value) : axis === "model" && row.value == null ? "No recorded model" : findingValueLabel(row.value)}</span>
                    <small>{Number(row.sessions).toLocaleString()} traces</small>
                </button>)}
                {result.status === "ready" && !result.rows.length && <p>No matching values.</p>}
                {result.rows.length === 50 && <p>First 50 values by traces. Search to find other values.</p>}
            </div>
        </>}
    </div>;
}
